import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { User, Lock } from 'lucide-react'

export default function BasicAuthSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="name"
          label="Username"
          icon={<User size={16} />}
          value={watch('basic.username') || ''}
          onChange={(value) => setValue('basic.username', value)}
          autoComplete="new-username"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="password"
          label="Password"
          icon={<Lock size={16} />}
          value={watch('basic.password') || ''}
          onChange={(value) => setValue('basic.password', value)}
          autoComplete="new-password"
          skipPasswordValidation={true}
          className={styles.input}
        />
      </div>
    </>
  )
}
